import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=47346e86&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47346e86')) {
      api.createRecord('47346e86', component.options)
    } else {
      api.reload('47346e86', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=47346e86&", function () {
      api.rerender('47346e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/Sidebar.vue"
export default component.exports